import { toLocalISODate } from './selfiePeriod';
import { parsePtNumber, parseMoney } from './money';
import { PAYMENT_RECURRENCE_MONTHS } from '../components/liabilities/debtTypes';

/** Prestação equivalente mensal (alinhado com o backend). */
export function effectiveMonthlyPayment(liability) {
  const amount = parseMoney(liability?.monthly_payment);
  if (amount <= 0) return 0;
  const divisor = PAYMENT_RECURRENCE_MONTHS[liability.payment_recurrence];
  if (!divisor) return 0;
  return Math.round((amount / divisor) * 100) / 100;
}

/** Sugestão de extra mensal: metade da prestação mensal. */
export function suggestHalfExtraMonthly(liability) {
  const monthly = effectiveMonthlyPayment(liability);
  if (monthly <= 0) return 0;
  return Math.round(monthly * 50) / 100;
}

/** Data-alvo ≈ hoje + meses de amortização acelerada. */
export function targetDateFromPayoffMonths(months) {
  const count = Math.max(1, Number(months) || 1);
  const today = new Date();
  const result = new Date(today);
  result.setMonth(result.getMonth() + count);
  const day = Math.min(today.getDate(), 28);
  result.setDate(day);
  return toLocalISODate(result);
}

export function formatExtraForApi(value) {
  const n = parsePtNumber(String(value));
  if (n == null || n <= 0) return null;
  return n.toFixed(2);
}

/** Data de fim prevista a partir do plano activo ou da simulação. */
export function predictedPayoffDateFromPlan(plan) {
  if (!plan) return null;
  if (plan.predicted_payoff_date) return plan.predicted_payoff_date;
  const snap = plan.simulation_snapshot || {};
  if (snap.predicted_payoff_date) return snap.predicted_payoff_date;
  const months = snap.accelerated_payoff_months;
  if (months == null || snap.requires_more_data) return null;
  return targetDateFromPayoffMonths(months);
}

export function formatPayoffDatePt(isoDate) {
  if (!isoDate) return '';
  const parsed = new Date(isoDate);
  if (Number.isNaN(parsed.getTime())) return '';
  return parsed.toLocaleDateString('pt-PT', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
